import * as React from 'react';
import Card from 'antd/lib/card';
import Form from 'antd/lib/form';
import { Col } from 'antd';

type ContractWriteFormTemplateProps = {
  children: React.ReactNode;
  title: string;
  name: string;
  extra?: React.ReactNode;
};

const ContractWriteFormTemplate = ({ children, title, name, extra }: ContractWriteFormTemplateProps) => {
  return (
    <Col xl={12} xs={24}>
      <Card title={title} bordered style={{ minWidth: 'auto', minHeight: '100%' }} extra={extra}>
        <Form.Item name={name}>{children}</Form.Item>
      </Card>
    </Col>
  );
};

ContractWriteFormTemplate.defaultProps = {
  extra: <></>,
};

export default ContractWriteFormTemplate;
